import React, { Component } from "react";
import cover from "../images/main_cover.jpg";
import logo from "../images/logo.jpg";
import logoTitle from "../images/logo-title.png";
import Menu from "./Menu";
import { connect } from "react-redux";
import { Waypoint } from "react-waypoint";
import { setActiveMenu } from "./../actions";

class Header extends Component {
	render() {
		return (
			<header
				style={{
					height: "90vh",
					minHeight: "430px"
					// backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,.5), rgba(0,0,0,0)), url(${cover})`,
					// backgroundSize: "cover",
					// backgroundPosition: "bottom center"
				}}>
				<div className="parallax-container">
					<div className="parallax is-preload">
						<div className="gradient" />
						<img
							onLoad={() => {
								document.querySelector(".parallax").classList.remove("is-preload");
								console.log("loaded");
							}}
							id="mainImg"
							src={cover}
							alt=""
							style={{
								position: "absolute",
								padding: "60vh 50vw",
								bottom: "0px",
								width: "0px",
								height: "0px",
								zIndex: "-1",
								background: `url(${cover}) center bottom / cover no-repeat`,
								opacity: "1"
							}}
						/>
					</div>
				</div>

				<div className="main-cover">
					<Menu />
					<Waypoint onEnter={() => this.props.setActiveMenu()} />
					<div className="divider" style={{ flexGrow: 1 }} />
					<div className="logo">
						<div className="logo-header">
							<div className="wrapper">
								<p className="title">
									<img src={logoTitle} alt="" />
								</p>
								<img className="logo-img" src={logo} alt="" />
							</div>

							<div className="slogan">
								<h3>{this.props.langBase.slogan}</h3>
							</div>
						</div>
					</div>
				</div>

				<Waypoint bottomOffset={300} onEnter={() => this.props.setActiveMenu(1)} />
			</header>
		);
	}
}

const mapStateToProps = (state) => ({
	langBase: state.langBase,
	activeMenu: state.activeMenu
});

const mapDispatchToProps = {
	setActiveMenu
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
